/**
 * Трекинг активности пользователя (визиты по зонам) для админ-панели.
 * Пингуем бэкенд, чтобы видеть, что залогиненный человек зашёл снова,
 * даже если он не выходил из системы.
 */
import { fetchWithAuthRetry } from '../auth/authenticatedFetch';
import { getWellandStoredToken, clearWellandToken, WELLAND_USER_KEY } from '../auth/storageKeys';

/** Принудительный выход при блокировке аккаунта (сервер вернул 403). */
function forceLogoutBlocked() {
    try { clearWellandToken(); } catch { /* ignore */ }
    try { localStorage.removeItem(WELLAND_USER_KEY); } catch { /* ignore */ }
    // Гасим refresh-cookie на сервере и уводим на вход
    try { fetchWithAuthRetry('/api/auth/logout', { method: 'POST' }).catch(() => {}); } catch { /* ignore */ }
    if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/auth')) {
        window.location.href = '/auth';
    }
}

/** landing | dashboard | app — по текущему пути */
export function areaFromPath(pathname = '') {
    if (pathname.startsWith('/app')) return 'app';
    if (pathname.startsWith('/dashboard')) return 'dashboard';
    return 'landing';
}

let _lastPingAt = 0;
const MIN_INTERVAL_MS = 25_000; // не чаще раза в 25с с клиента (сервер ещё дедуплицирует)

/**
 * Отправляет пинг активности (только для залогиненного пользователя).
 * @param {string} [area] явная зона; иначе — из window.location
 */
export async function pingActivity(area) {
    try {
        // Только для залогиненных: на публичных страницах анонимов не дёргаем
        if (!getWellandStoredToken()) return;
        const now = Date.now();
        if (now - _lastPingAt < MIN_INTERVAL_MS) return;
        _lastPingAt = now;

        const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
        const a = area || areaFromPath(pathname);

        const res = await fetchWithAuthRetry('/api/activity/ping', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ area: a, path: pathname }),
        });
        // 403 от authRequired = аккаунт заблокирован → принудительный выход
        if (res && res.status === 403) forceLogoutBlocked();
    } catch {
        /* тихо игнорируем — трекинг не должен ломать UX */
    }
}
